import { Errors, request } from "#/utils/request";

export type RequestData = {
  codigoComissionado: string;
  idProduto: number;
  documento: string;
};

export interface MinMaxDataResponse {
  data: MinMaxData;
  errors: Errors;
}

export interface MinMaxData {
  vl_bem_minimo: number;
  vl_bem_maximo: number;
  vl_pc_minimo: number;
  vl_pc_maximo: number;
}

/**
 * @function find - GET Data
 * @param codigoComissionado - identity client
 * @param idProduto - identity product
 * @param documento - client document
 */
export const findMinMaxByCodCommissioned = async ({
  codigoComissionado,
  idProduto,
  documento,
}: RequestData) => {
  if (idProduto > 0 && codigoComissionado) {
    return (
      await request.get<MinMaxDataResponse>(
        `/validation/valores-min-max?codigoComissionado=${codigoComissionado}&idProduto=${idProduto}&documento=${documento}`
      )
    ).data;
  }
};
